<script lang="ts">
</script>

<div class="relative mr-2">
	<img class="w-4 shadow-lg" src="scwallet/ellipse.svg" alt="" />
	<img class="absolute inset-1 w-2" src="scwallet/ellipse-73.svg" alt="" />
</div>
